module.exports = __webpack_public_path__ + "img/teacher.b1111283.svg";